export function UserCountriesBoxConstructor(services, type) {

  const joint = services.joint;
  return joint.shapes.html.AbstractBoxWithInPort.extend({
    defaults: joint.util.deepSupplement({
      'labelText': services.$translate.instant('parameters/quick_replies/details/user_countries'),
      'labelFill': '#4DAC50',
      'type': 'html.UserCountriesBox'
    }, joint.shapes.html.AbstractBoxWithInPort.prototype.defaults)
  });

}
